import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPartiallyHealthy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={38}
    height={38}
    fill="none"
    aria-label="PartiallyHealthy"
    {...props}
  >
    <circle cx={18.9} cy={18.9} r={15.12} fill="#E07524" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M27.085 12.715a1.47 1.47 0 0 1 0 2.075L17.084 24.791c-.794.794-2.08.8-2.88.013l-3.937-3.868a1.468 1.468 0 0 1 2.057-2.093l3.308 3.25 9.377-9.378a1.47 1.47 0 0 1 2.076 0"
      clipRule="evenodd"
    />
    <rect
      width={2.835}
      height={15.497}
      x={15.12}
      y={13.608}
      fill="#fff"
      rx={1.417}
      transform="rotate(-45 15.12 13.608)"
    />
  </svg>
);
export default SvgPartiallyHealthy;
